<div>
  <h2>Field Mapping</h2>
  <p nz-typography>
    Map required fields to the corresponding CSV columns, this mapping will be saved and reused for future uploads.
  </p>

  <div class="mapping-table-container mapping-table-spacer">
    <form [formGroup]="form">
      <nz-table [nzData]="fields" [nzBordered]="true" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Target Field</th>
            <th>File Name</th>
            <th>Source Column → Maps To</th>
          </tr>
        </thead>
        <tbody formArrayName="mappings">
          <tr *ngFor="let field of fields; let i = index" [formGroupName]="i">
            <td>
              <nz-tag nzColor="blue" class="target-tag">
                {{ field.key }}
              </nz-tag>
              <div class="desc">
                {{ field.desc }}
              </div>
            </td>

            <td>
              <nz-select
                formControlName="file"
                nzPlaceHolder="Select File"
                class="full-width"
                (ngModelChange)="onFileChange(i)"
                [nzStatus]="
                  form.get(['mappings', i, 'file'])?.invalid && form.get(['mappings', i, 'file'])?.touched
                    ? 'error'
                    : ''
                "
              >
                <nz-option *ngFor="let file of fileOptions" [nzValue]="file" [nzLabel]="file"></nz-option>
              </nz-select>
            </td>

            <td>
              <nz-select
                formControlName="column"
                nzPlaceHolder="Select Column"
                class="full-width"
                [nzDisabled]="!hasSelectedFile(i)"
                [nzStatus]="
                  form.get(['mappings', i, 'column'])?.invalid && form.get(['mappings', i, 'column'])?.touched
                    ? 'error'
                    : ''
                "
              >
                <nz-option *ngFor="let col of getColumnOptions(i)" [nzValue]="col" [nzLabel]="col"></nz-option>
              </nz-select>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </form>
  </div>

  <div class="s3-btn-panel save-mapping-btn-panel">
    <button nz-button nzSize="large" (click)="back.emit()" class="back-btn">
      <span>Back</span>
    </button>
    <button
      class="next-btn"
      nzSize="large"
      nz-button
      nzType="default"
      (click)="saveAndValidateMapping.emit()"
      [disabled]="form.invalid"
      [nzLoading]="isLoading"
    >
      <span>Validate & Save Mapping</span>
    </button>
  </div>

  <app-validation-logs [logs]="validationLogs"></app-validation-logs>

  <div class="s3-btn-panel">
    <button
      class="next-btn"
      nzSize="large"
      nz-button
      nzType="default"
      [disabled]="!filesValidated || isProcessing || isPublishing"
      [nzLoading]="isProcessing"
      (click)="process.emit()"
    >
      <span nz-icon nzType="setting" nzTheme="outline"></span><span>Process</span>
    </button>
    <button
      class="next-btn"
      nzSize="large"
      nz-button
      nzType="default"
      (click)="export.emit()"
      [disabled]="!(uploadFilesService.isFileProcessed$ | async) || isPublishing"
      [nzLoading]="isPublishing"
    >
      <span nz-icon nzType="upload" nzTheme="outline"></span><span>Publish Processed File</span>
    </button>
  </div>
</div>
